import { SingleCheckboxFieldProps } from "./SingleCheckboxField";
import React, { useEffect } from "react";
import { SingleCheckboxFieldValue } from "../../types/fieldTypes";

export const useSingleCheckboxField = (props: SingleCheckboxFieldProps) => {
  const [localValues, setLocalValues] =
    React.useState<SingleCheckboxFieldValue>(props.value);

  useEffect(() => {
    setLocalValues(props.value);
  }, [props.value]);

  return { localValues, setLocalValues };
};
